import React, { useRef, useCallback } from 'react';
import { CircleSpinner } from 'react-spinners-kit';
import Header from '../../../components/Common/Header/Header';
import ContentApp from '../../../components/ContentApp';
import EmptyActivity from '../../../components/Common/EmptyActivity/EmptyActivity';
import PaymentLinkItem from '../../../components/PaymentLinkItem/PaymentLinkItem';
import { useTranslation } from 'react-i18next';
import useRealtimeReservations from '../../../hooks/useRealtimeReservations';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const PaymentsLink = ({ history }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const filterFromUrl = queryParams.get('filter');
  const { reservations, loading, loadingMore, hasMore, fetchMoreReservations } =
    useRealtimeReservations(new Date(), filterFromUrl, null, { ReservationTypeInclude: ['LINK'] });

  const observer = useRef();

  const lastReservationRef = useCallback(
    (node) => {
      if (loading || loadingMore) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          fetchMoreReservations();
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, loadingMore, hasMore, fetchMoreReservations],
  );

  return (
    <>
      <Header title={t('homeLinkTitle')} hasBackground={true} showBack={true} />

      <ContentApp>
        {loading ? (
          <div className='loaderDiv'>
            <CircleSpinner
              className='spinner-app mx-auto'
              style={{ margin: 'auto' }}
              size={40}
              color='var(--color-font-primary)'
            />
          </div>
        ) : reservations?.length === 0 ? (
          <div className='mt-2'>
            <EmptyActivity title={t('noPaymentLinks')} />
          </div>
        ) : (
          <div className='mt-2'>
            {reservations.map((r, index) => {
              if (index === reservations.length - 1) {
                return (
                  <div ref={lastReservationRef} key={r.id}>
                    <PaymentLinkItem
                      activity={r}
                      date={r.createdDate}
                      rightText={r.amount}
                      index={index}
                      lastIndex={reservations.length - 1}
                      handleClick={() => history.push(`/link-details?id=${r.id}`)}
                    />
                  </div>
                );
              } else {
                return (
                  <PaymentLinkItem
                    key={r.id}
                    activity={r}
                    date={r.createdDate}
                    rightText={r.amount}
                    index={index}
                    lastIndex={reservations.length - 1}
                    handleClick={() => history.push(`/link-details?id=${r.id}`)}
                  />
                );
              }
            })}
            {loadingMore && hasMore && (
              <div className='p-3 d-flex justify-content-center'>
                <CircleSpinner
                  className='spinner-app mx-auto'
                  style={{ margin: 'auto' }}
                  size={40}
                  color='var(--color-font-primary)'
                />
              </div>
            )}
          </div>
        )}
      </ContentApp>
    </>
  );
};

export default PaymentsLink;
